import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { createElementNavigationMenuItems } from '@core/constants';
import { NavMenuItem } from '@core/types';
import { DialogRef } from '@ngneat/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { PERMISSIONS, PermissionService } from '@auth';
import { isMobileView } from '@core/utils';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';
import { IconComponent } from '@shared/components/ui';

@Component({
  selector: 'app-add-element',
  imports: [CommonModule, IconComponent, TranslateModule],
  templateUrl: './add-element.component.html',
  styleUrls: ['./add-element.component.scss'],
})
export class AddElementComponent {
  readonly _permissionService = inject(PermissionService);
  createPopupNavigationItems: NavMenuItem[] = [];
  protected readonly isMobileView = isMobileView();
  private readonly _router = inject(Router);
  private readonly _dialogRef: DialogRef;
  private readonly _bottomSheet: NgxBottomSheetService;

  constructor() {
    this.createPopupNavigationItems = createElementNavigationMenuItems;
    if (isMobileView()) {
      this._bottomSheet = inject(NgxBottomSheetService);
    } else {
      this._dialogRef = inject(DialogRef);
    }
  }

  closeDialogBox(): void {
    if (isMobileView()) {
      this._bottomSheet.close();
    } else {
      this._dialogRef.close();
    }
  }

  navigate(url: string): void {
    if (!url) return;
    this._router
      .navigateByUrl('/', {
        skipLocationChange: true,
      })
      .then(() => {
        this._router
          .navigate([url], {
            queryParams: { create: true },
          })
          .then(() => {
            this.closeDialogBox();
          });
      });
  }

  hasPermission(permissions: PERMISSIONS[]) {
    if (permissions && permissions.length) {
      return permissions.some((permission: PERMISSIONS) => this._permissionService.hasPermission(permission));
    }

    return true;
  }
}
